<h2 class="list-title">
  @if (icon) {
    <ion-icon [name]="icon" class="list-title__icon no-pointer-events"></ion-icon>
  }
  <ng-content></ng-content>
</h2>
@if (small) {
  <small class="small">{{ small }}</small>
}

@if (list?.itemIds?.length > 0) {
  <small class="small num-items">
    {{ list.itemIds.length }}@if (list.nextToken) {
    <span class="more-items">+</span>
  }
</small>
}
